import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { toast } from 'sonner'
import './index.css'
import { router } from './routes'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { WebAnalytics } from '@/components/WebAnalytics'
import { ApiRequestError } from '@/lib/api'
import { initPostHog } from '@/lib/posthog'
import { BootReveal } from '@/components/BootReveal'

// Initialize PostHog analytics — gated by cookie consent.
// If the user has not accepted cookies, this is a no-op.
// PostHog will be initialized later when they click "Accept".
initPostHog()

// Global handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  // ApiRequestError instances are handled by callers — skip
  if (event.reason instanceof ApiRequestError) return

  console.error(JSON.stringify({
    timestamp: new Date().toISOString(),
    level: 'error',
    module: 'global',
    message: 'Unhandled promise rejection',
    error: event.reason?.message ?? String(event.reason),
  }))

  toast.error('Something went wrong. Please try again.')
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <BootReveal />
      <ErrorBoundary>
        <RouterProvider router={router} />
        <WebAnalytics />
      </ErrorBoundary>
    </HelmetProvider>
  </StrictMode>,
)
